import { Link } from "react-router-dom";
import { useLang } from "../lib/i18n";
import { LogoMark } from "./Logo";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden">
      <div className="grid grid-cols-2">
        <div className="bg-[var(--ink)] text-white px-5 md:px-10 pt-16 pb-10">
          <p className="f-mono text-[11px] uppercase tracking-[0.3em] text-[var(--acid)] mb-6">01 — {t("street")}</p>
          <Link to="/collections/streetwear" data-testid="footer-link-streetwear" className="f-street uppercase text-3xl md:text-5xl hover:text-[var(--acid)] transition-colors duration-300">{t("enterStreet")} →</Link>
        </div>
        <div className="bg-[var(--ivory)] text-[var(--navy)] px-5 md:px-10 pt-16 pb-10 text-right">
          <p className="f-mono text-[11px] uppercase tracking-[0.3em] text-[var(--gold)] mb-6">02 — {t("oldmoney")}</p>
          <Link to="/collections/old-money" data-testid="footer-link-oldmoney" className="f-serif italic text-3xl md:text-5xl hover:text-[var(--gold)] transition-colors duration-300">← {t("enterOld")}</Link>
        </div>
      </div>
      <div className="relative bg-[var(--ink)]">
        <div className="absolute inset-y-0 right-0 w-1/2 bg-[var(--ivory)]" />
        <p className="relative f-wordmark text-white mix-blend-difference text-[17vw] leading-[0.85] tracking-[0.02em] text-center py-6 select-none">ANVOCRA</p>
      </div>
      <div className="bg-[var(--ink)] text-zinc-400 px-5 md:px-10 py-6 flex flex-col md:flex-row gap-3 items-center justify-between f-mono text-[11px] uppercase tracking-[0.2em]">
        <span className="flex items-center gap-3"><LogoMark size={18} /> {t("footer")}</span>
        <span>© {year} ANVOCRA — {t("rights")}</span>
      </div>
    </footer>
  );
};
